import {Platform, StyleSheet, ViewStyle} from 'react-native';

const style = StyleSheet.create({
  header: {
    flexDirection: 'row',
    width: '100%',
    zIndex: 3,
  },
  stickyHeader: {
    ...Platform.select({
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      web: {
        position: 'sticky',
        top: 0,
        zIndex: 10,
      } as ViewStyle,
      native: {
        position: 'relative',
      },
    }),
  },
});

export {style};
